export default __webpack_public_path__ + "static/media/mface.bb9cccd2.png";